import { render, staticRenderFns } from "./phoneSingleChoice.vue?vue&type=template&id=b25cc0ce"
import script from "./phoneSingleChoice.vue?vue&type=script&lang=js"
export * from "./phoneSingleChoice.vue?vue&type=script&lang=js"
import style0 from "./phoneSingleChoice.vue?vue&type=style&index=0&id=b25cc0ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports